<ng-template #signpost_dependencies_viewer>
    <label class="clr-control-label">Export:</label>
    <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-primary btn-sm" (click)="exportGraph()">Graph</button>
    </div>
</ng-template>

<ng-template #signpost_clusters_viewer>
  <label class="clr-control-label">Ignored ports:</label>
  <div style="margin-bottom: 20px;">
    @for(port of ignoredPorts; track port) {
      <span class="label" (click)="removeIgnoredPort(port)" style="cursor: pointer;">{{ port }}</span>
    }
    @if(ignoredPorts.length == 0) {
      <span>no ignored ports</span>
    }
    <input clrInput type="text" [(ngModel)]="newPortStr" style="margin-top: 0px;"/><button class="btn btn-sm" (click)="addNewIgnoredPort()">add to ignored ports</button>
  </div>

    <label class="clr-control-label">Reload:</label>
    <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-primary btn-sm" (click)="reloadUiAndRecomputeDistances()">UI</button>
        <button class="btn btn-primary btn-sm" (click)="reloadDataAndRecomputeDistances()">Data and UI</button>
    </div>

    <label class="clr-control-label">Export:</label>
    <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-primary btn-sm" (click)="exportGraph()">Graph</button>
    </div>
</ng-template>

<ng-template #signpost_appsgroups_viewer>
    <label class="clr-control-label">Reload:</label>
    <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-primary btn-sm" (click)="reloadUiAndRecomputeDistances()">UI</button>
        <button class="btn btn-primary btn-sm" (click)="reloadDataAndRecomputeDistances()">Data and UI</button>
    </div>

    <label class="clr-control-label">Export:</label>
    <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-primary btn-sm" (click)="exportGraphAs('svg')" title="Picture that scales without losing quality">SVG</button>
        <button class="btn btn-primary btn-sm" (click)="exportGraphAs('png')" title="Picture for documents and slides">PNG</button>
        <button class="btn btn-primary btn-sm" (click)="exportGraphAs('drawio')" title="Diagram to edit in draw.io (diagrams.net)">draw.io</button>
    </div>
</ng-template>

<ng-template #signpost_networks_viewer>
    <label class="clr-control-label">Export:</label>
    <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-primary btn-sm" (click)="exportGraphAs('svg')" title="Picture that scales without losing quality">SVG</button>
        <button class="btn btn-primary btn-sm" (click)="exportGraphAs('png')" title="Picture for documents and slides">PNG</button>
    </div>
</ng-template>

<ng-template #signpost_protocol_analysis>
    <label class="clr-control-label">Export:</label>
    <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-primary btn-sm" (click)="exportGraph()">Graph</button>
    </div>
</ng-template>

<div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; display: flex; flex-flow: column;">

    <clr-alert [clrAlertType]="'danger'" [clrAlertAppLevel]="true" *ngIf="failureMode && !isLoading">
        <clr-alert-item>
            <span class="alert-text">Cannot load data from DC Netscope API. Please check the diagnostic page.</span>
            <div class="alert-actions">
                <a routerLink="/diagnostic" routerLinkActive="active">
                    <button class="btn alert-action">
                        <cds-icon shape="checkbox-list"></cds-icon>
                        Diagnostic
                    </button>
                </a>
            </div>
        </clr-alert-item>
    </clr-alert>

    <div class="clr-row" style="position: relative; height: 100%; bottom: 0px; width: 100%; margin: 0px;">
        <clr-tabs style="background-color: var(--cds--alias-object-app-background); width: 100%; height: 100%;">
            <clr-tab>
                <button id="flows_visualisation_button" clrTabLink style="margin-left: 25px;" (click)="focusedOnVisualizationTab()">{{ 'dcnetscope.flows_tab_visualisation' | transloco }}</button>
                <clr-tab-content>
                @if (selectedView === 'protocol-analysis') {
                    <div class="clr-row" style="position: absolute; margin-top: 5px; margin-left: 135px; z-index: 200;">
                      <span *ngFor="let selectionItem of currentSelection; let i = index">
                          <span *ngIf="i > 0" style="margin-right: 5px;">/</span>
                          <span (click)="selectProtocolNode(selectionItem)" style="cursor: pointer;">
                              <span class="label {{ i === currentSelection.length -1 ? 'label-info' : '' }}">{{ selectionItem.label }}</span>
                          </span>
                      </span>
                    </div>
                }
                    <div style="position: absolute; left: 0px; right: 0px; top: 35px; bottom: 0px;">
                        <div class="clr-row" style="margin: 0px; position: absolute; z-index: 999; width: 100%; top: 0px; right: 15px; float: right;  pointer-events: none;">
                            <div class="clr-col-9">
                            <span style="position: relative; z-index: 999; top: 5px; left: 15px; pointer-events: auto;">
                                <clr-signpost>
                                     <cds-icon shape="cog" solid clrSignpostTrigger></cds-icon>
                                     <clr-signpost-content [clrPosition]="'bottom-right'" *clrIfOpen>
                                         <div *ngIf="selectedView === 'dependencies-viewer'">
                                            <ng-container *ngTemplateOutlet="signpost_dependencies_viewer"></ng-container>
                                         </div>
                                         <div *ngIf="selectedView === 'protocol-analysis'">
                                            <ng-container *ngTemplateOutlet="signpost_protocol_analysis"></ng-container>
                                         </div>
                                         <div *ngIf="selectedView === 'clusters-viewer'">
                                            <ng-container *ngTemplateOutlet="signpost_clusters_viewer"></ng-container>
                                         </div>
                                         <div *ngIf="selectedView === 'apps-groups'">
                                            <ng-container *ngTemplateOutlet="signpost_appsgroups_viewer"></ng-container>
                                         </div>
                                         <div *ngIf="selectedView === 'networks-viewer'">
                                            <ng-container *ngTemplateOutlet="signpost_networks_viewer"></ng-container>
                                         </div>
                                     </clr-signpost-content>
                                </clr-signpost>

                                <ng-container>
                                    <span style="margin-left: 10px;">
                                        <span class="badge" style="height: 1.1rem; cursor: pointer;" (click)="zoomInVisualisation()" *ngIf="showCameraButtons">
                                          <cds-icon shape="zoom-in"></cds-icon>
                                          <span class="clr-sr-only">zoom in</span>
                                        </span>

                                        <span class="badge" style="height: 1.1rem; cursor: pointer;" (click)="zoomOutVisualisation()" *ngIf="showCameraButtons">
                                          <cds-icon shape="zoom-out"></cds-icon>
                                          <span class="clr-sr-only">zoom out</span>
                                        </span>

                                        <span class="badge" style="height: 1.1rem; cursor: pointer;" (click)="recenterVisualisation()" *ngIf="showCameraButtons">
                                          <cds-icon shape="crosshairs"></cds-icon>
                                          <span class="clr-sr-only">re-center</span>
                                        </span>


                                        @if(selectedView === 'clusters-viewer'){
                                          <div class="btn-group btn-sm" style="background-color: var(--cds--alias-object-app-background); backdrop-filter: blur(10px);">
                                            <div class="checkbox btn">
                                              <input type="checkbox" id="btn-check-infrastructure" [(ngModel)]="clusterViewerVisibleResourcesOptions.infrastructure" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                              <label for="btn-check-infrastructure">Infrastructure</label>
                                            </div>
                                            <div class="checkbox btn">
                                              <input type="checkbox" id="btn-check-external_ips" [(ngModel)]="clusterViewerVisibleResourcesOptions.external_ips" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                              <label for="btn-check-external_ips">External IPs</label>
                                            </div>
                                            <div class="checkbox btn">
                                              <input type="checkbox" id="btn-check-unknown_ips" [(ngModel)]="clusterViewerVisibleResourcesOptions.unknown_ips" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                              <label for="btn-check-unknown_ips">Unknown IPs</label>
                                            </div>
                                            <div class="checkbox btn">
                                              <input type="checkbox" id="btn-check-internet" [(ngModel)]="clusterViewerVisibleResourcesOptions.internet" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                              <label for="btn-check-internet">Internet</label>
                                            </div>
                                          </div>

                                          @if (clusterViewerVisibleResourcesOptions.internet) {
                                            <div class="btn-group btn-sm" style="background-color: var(--cds--alias-object-app-background); backdrop-filter: blur(10px);">
                                              <div class="radio btn">
                                                <input type="radio" name="btn-group-demo-radios" id="btn-internet-asns-radio" value="asns" [(ngModel)]="clusterViewerShowASNs" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                                <label for="btn-internet-asns-radio">Internet ASN</label>
                                              </div>
                                              <div class="radio btn">
                                                <input type="radio" name="btn-group-demo-radios" id="btn-internet-ips-radio" value="ips" [(ngModel)]="clusterViewerShowASNs" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                                <label for="btn-internet-ips-radio">Internet IPs</label>
                                              </div>
                                            </div>
                                          }
                                        }

                                      @if(selectedView === 'clusters-viewer'){
                                        <span class="badge" style="height: 1.1rem; cursor: pointer;">
                                          <input type="checkbox" id="toggle1" name="toggle-basic" value="option1" class="clr-toggle" [(ngModel)]="showIgnoredPorts" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                          <label for="toggle1" style="margin-left: 10px;">Show {{ignoredPorts.length}} ignored ports</label>
                                        </span>

                                        <span class="badge" style="height: 1.1rem; cursor: pointer;">
                                          <input type="checkbox" id="toggle1" name="toggle-basic" value="option1" class="clr-toggle" [(ngModel)]="draggableNodesEnabled"/>
                                          <label for="toggle1" style="margin-left: 10px;">Draggable nodes</label>
                                        </span>
                                      }
<!--                                      @if(selectedView === 'apps-groups' && ! environment.production) {-->
                                        <span class="badge" style="height: 1.1rem;"
                                              title="Split the links by the flows descriptions matching their flows">
                                          <label for="apps-groups-links-mode" style="margin-right: 5px;">Links:</label>
                                          <select id="apps-groups-links-mode" name="apps-groups-links-mode"
                                                  [(ngModel)]="appsGroupsLinksMode" (change)="reloadUi()">
                                            <option value="ignore" title="A single link between two nodes, whatever the descriptions">Ignore descriptions</option>
                                            <option value="status" title="One link per status of the flows: authorized (green), unauthorized (red), undescribed (grey, dashed)">By status</option>
                                            <option value="descriptions" title="One link per description matching some of the flows, named after it, and one (grey, dashed) for the undescribed flows">By description</option>
                                          </select>
                                        </span>
<!--                                      }-->
                                      @if(selectedView === 'apps-groups' && false){
                                        <span class="badge" style="height: 1.1rem; cursor: pointer;">
                                          <input type="checkbox" id="toggle1" name="toggle-basic" value="option1" class="clr-toggle" [(ngModel)]="showInternalFlowsAppsGroups" (change)="reloadUrlParametersUiAndRecomputeDistances();"/>
                                          <label for="toggle1" style="margin-left: 10px;">Show flows inside apps groups</label>
                                        </span>
                                      }

                                      @if(selectedView === 'clusters-viewer'){
                                        <span class="badge" style="height: 1.1rem; cursor: pointer;">
                                          @if (isComputingPositions) {
                                            <cds-icon shape="pause" (click)="stopComputingPositionsRequested=true"></cds-icon>
                                            <span class="spinner spinner-sm">Computing positions...</span>
                                          } @else {
                                            <cds-icon shape="play" (click)="reComputingPositionsRequested=true"></cds-icon>
                                          }
                                        </span>
                                      }

                                    </span>
                                </ng-container>

                                <ng-container *ngIf="selectedView === 'apps-groups'">
<!--                                    <span class="label label-blue" (click)="appsGroupsPanelOpened = !appsGroupsPanelOpened" style="cursor: pointer;">-->
<!--                                        <cds-icon shape="tree-view"></cds-icon>-->
<!--                                        apps groups file: {{ appsGroupsMode }}-->
<!--                                    </span>-->

                                    @if (selectedView == "apps-groups") {
                                        <select class="label" name="options" (change)="reloadUi()" [(ngModel)]="this.routingAlgorithm">
                                          <option value="automatic">Automatic</option>
                                          <option value="hybrid">Hybrid</option>
                                          <option value="optimized">Optimized</option>
                                          <option value="libavoid">Precise</option>
                                        </select>
                                        <span class="label">using {{ this.currentRoutingAlgorithm }}</span>
                                    }
                                </ng-container>
                            </span>
                            </div>

                            <div class="clr-col-1" style="text-align: center;">
                              <span id="dcnetscope-visualisation-topbar" class="badge badge-blue"
                                    style="margin-top: 10px; font-size: 1em; padding: 15px; border-radius: 2rem; background-color: black; pointer-events: auto; background-color: white;"
                                    *ngIf="this.selectedAppsGroups.length > 0">
                                  <span style="margin-right: 5px;" *ngIf="this.selectedAppsGroups.length == 1">
                                      {{ this.selectedAppsGroups[0].name }}
                                  </span>
                                  <span style="margin-right: 5px;" *ngIf="this.selectedAppsGroups.length == 2">
                                      {{ this.selectedAppsGroups[0].name }}
                                      <cds-icon shape="link" solid>
                                      </cds-icon>
                                      {{ this.selectedAppsGroups[1].name }}
                                  </span>
                                  |
                                  <cds-icon shape="recycle" solid style="cursor: pointer; margin-left: 5px;"
                                            (click)="navigateSelection('dependencies-viewer');">
                                  </cds-icon>
                                  <cds-icon shape="chat-bubble" solid style="cursor: pointer; margin-left: 5px;"
                                            (click)="navigateSelection('protocol-analysis');">
                                  </cds-icon>
                                  <cds-icon shape="organization" solid
                                            style="cursor: pointer; margin-left: 5px; margin-right: 5px;"
                                            (click)="navigateSelection('clusters-viewer');">
                                  </cds-icon>
                                  |
                                  <cds-icon shape="times-circle" solid style="cursor: pointer; margin-left: 5px;"
                                            (click)="removeSelection();">
                                  </cds-icon>
                              </span>
                            </div>

                            <div class="clr-col-2" style="text-align: right;">
                                @if (isSlow) {
                                  <clr-tooltip>
                                    <span style="float: right;" clrTooltipTrigger>
                                      <cds-icon shape="exclamation-triangle"></cds-icon>
                                      slow rendering
<!--                                      {{rendererVersion}}-->
                                    </span>
                                    <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'sm'">
                                      We detected that too many data would be displayed. We switched back to a simplier renderer : links may not be optimal. Don't hesitate to focus on a resource to get a cleaner visualisation.
                                    </clr-tooltip-content>
                                  </clr-tooltip>
                                }
                                <div class="btn-group btn-outline-primary btn-icon btn-sm" style="margin-top: 10px; pointer-events: auto; background-color: var(--cds--alias-object-app-background); backdrop-filter: blur(10px);" *ngIf="selectedView !== 'apps-groups' && selectedView !== 'networks-viewer'">
                                    <div class="radio btn">
                                        <input type="radio" name="btn-group-switch_view-radios" id="btn-demo-radio-1"
                                               [ngModel]="selectedView" value="dependencies-viewer"
                                               (click)="navigateSelection('dependencies-viewer');">
                                        <label for="btn-demo-radio-1">
                                            <cds-icon shape="recycle" title="Check"></cds-icon>
                                        </label>
                                    </div>
                                    <div class="radio btn">
                                        <input type="radio" name="btn-group-switch_view-radios" id="btn-demo-radio-2"
                                               [ngModel]="selectedView" value="protocol-analysis"
                                               (click)="navigateSelection('protocol-analysis');">
                                        <label for="btn-demo-radio-2">
                                            <cds-icon shape="chat-bubble" title="Check"></cds-icon>
                                        </label>
                                    </div>
                                    <div class="radio btn">
                                        <input type="radio" name="btn-group-switch_view-radios" id="btn-demo-radio-3"
                                               [ngModel]="selectedView" value="clusters-viewer"
                                               (click)="navigateSelection('clusters-viewer');">
                                        <label for="btn-demo-radio-3">
                                            <cds-icon shape="organization" title="Check"></cds-icon>
                                        </label>
                                    </div>
                                </div>
                                <span *ngIf="selectedView !== 'protocol-analysis'">
                                  <span style="" *ngIf="groupsApps !== undefined && groupsApps.length > 0 && selectedView === 'apps-groups'">
  <!--                                    <span *ngFor="let group of groupsApps" class="p6"-->
  <!--                                          style="margin-left: 5px; margin-right: 5px; display: inline-block;">-->
  <!--                                        <span class="badge" style="background: {{group.color}}"> </span> {{group.name}}-->
  <!--                                    </span>-->
                                  </span>
                                  <span style="" *ngIf="selectedAppsGroups.length > 0 && selectedView !== 'apps-groups'">
  <!--                                    <span *ngFor="let group of selectedAppsGroups" class="p6"-->
  <!--                                          style="margin-left: 5px; margin-right: 5px; display: inline-block;">-->
  <!--                                        <span class="badge" style="background: {{group.color}}"> </span> {{group.name}}-->
  <!--                                    </span>-->
                                  </span>
                              </span>
                                <span *ngIf="isLoading">
                                <clr-spinner [clrSmall]="true">Loading ...</clr-spinner>
                            </span>
                            </div>
                        </div>

                        @if(selectedView == "apps-groups") {
                          <app-apps-groups-panel></app-apps-groups-panel>
                        }

                        <div #divFlowsSvg id="divFlowsSvg" style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; overflow: hidden;"></div>

                        <app-apps-groups-panel
                          #appsGroupsPanel
                          *ngIf="selectedView === 'apps-groups'"
                          [(open)]="appsGroupsPanelOpened"
                          [selectedFile]="appsGroupsMode"
                          [appGroupStates]="appGroupStates"
                          [vmVisibilityStates]="vmVisibilityStates"
                          [memberRoles]="memberRoles"
                          [hiddenAppsGroups]="hiddenAppsGroups"
                          (selectedFileChange)="onAppsGroupsFileChanged($event)"
                          (viewStateChanged)="onAppsGroupsViewStateChanged()"
                          (appsGroupsSaved)="onAppsGroupsSaved($event)">
                        </app-apps-groups-panel>
                        <netscope-common-flowview-legend #legend>
                        </netscope-common-flowview-legend>
                    </div>
                </clr-tab-content>
            </clr-tab>

            <clr-tab>
                <button id="flows_datatable_button" clrTabLink (click)="focusedOnDatagridTab()">{{ 'dcnetscope.flows_tab_datagrid' | transloco }}</button>
                <clr-tab-content>
                    <div class="clr-row" style="padding: 10px;">
                        <div class="clr-col-12">
                            <app-netscope-flows-datagrid
                              [thirdPartyRefresh]="datatableTabFlowsRepository?.refresh"
                              [flowsRepository]="datatableTabFlowsRepository"
                              [totalItemsCount]="datatableTabFlowsRepository?.totalItemsCount"
                              [flowDetails]="datatableTabFlowsRepository?.dashboardFlows"
                              [temporalParameter]="temporalParameter"
                              [bidirectional]="selectedView === 'apps-groups'"
                              [showHosts]="true"
                              [switchFocus]="switchFocus"
                              [exportCsvEnabled]="true"
                              [callExportCsv]="exportCSV"
                            ></app-netscope-flows-datagrid>
                        </div>
                    </div>
                </clr-tab-content>
            </clr-tab>
        </clr-tabs>
    </div>
</div>

<clr-side-panel id="flowsSidePanel" [clrSidePanelSize]="'lg'" [(clrSidePanelOpen)]="sidePanelOpened" [clrSidePanelStaticBackdrop]="false" [clrFocusOnViewInit]="true" #flowsSidePanel>
  <h3 class="side-panel-title" style="width: 100%;">

    {{ sidePanelTitle }}

    @if (sidePanelResourceUuid !== undefined && !sidePanelHideFocus) {
      @if (sidePanelIsAlreadyFocused) {
        <button class="btn btn-sm btn-primary" (click)="switchFocus({id: sidePanelResourceUuid})">unfocus</button>
      } @else {
        <button class="btn btn-sm btn-primary" (click)="switchFocus({id: sidePanelResourceUuid})">focus</button>
      }
      <button class="btn btn-sm btn-warning" (click)="switchIgnore({id: sidePanelResourceUuid})">ignore</button>
    }
  </h3>
  <div class="side-panel-body">
    <div class="clr-row">
      <div class="clr-col">
        <div echarts id="flowview-side-panel-protocols-chart" [options]="sidePanelProtocolsOptions" class="demo-chart" style="height: 300px;"></div>
      </div>
      <div class="clr-col">
        <div echarts id="flowview-side-panel-origins-chart" [options]="sidePanelOriginsOptions" class="demo-chart" style="height: 300px;"></div>
      </div>
    </div>
    <div class="clr-row">
      <div class="clr-col">
        <app-netscope-flows-datagrid
          [thirdPartyRefresh]="sidePanelRepository?.refresh"
          [flowsRepository]="sidePanelRepository"
          [totalItemsCount]="sidePanelRepository?.totalItemsCount"
          [flowDetails]="sidePanelRepository?.dashboardFlows"
          [mergeSourceAndTarget]="true"
          [temporalParameter]="temporalParameter"
          [ignoreFilters]="true"
          [showHosts]="false" [hidePacketsExchanged]="true"
          [perPortRow]="true"
          [showPortInline]="true"
          [switchFocus]="switchFocus"
          [exportCsvEnabled]="true"
          [callExportCsv]="exportRowPerPortCSV">
        </app-netscope-flows-datagrid>
      </div>
    </div>
  </div>
  <div class="side-panel-footer">
<!--    <button type="button" class="btn btn-outline" (click)="sidePanelOpened = false">Cancel</button>-->
    <button type="button" class="btn btn-primary" (click)="sidePanelOpened = false">Close</button>
  </div>
</clr-side-panel>


